import { useCallback } from 'react';
import { SIGNUP_ROUTE } from 'features/authentication/signup/constants/signup-links';
import { useHistory, useLocation } from 'react-router-dom';

export const useGoBackToEmailStep = () => {
    const history = useHistory();
    const location = useLocation();

    return useCallback(() => {
        history.replace({
            pathname: SIGNUP_ROUTE,
            search: location.search,
        });
    }, [history, location]);
};
